import { render, staticRenderFns } from "./PostsListVo.vue?vue&type=template&id=b4baa198&scoped=true&"
import script from "./PostsListVo.vue?vue&type=script&lang=js&"
export * from "./PostsListVo.vue?vue&type=script&lang=js&"
import style0 from "./PostsListVo.vue?vue&type=style&index=0&id=b4baa198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4baa198",
  null
  
)

export default component.exports